import * as React from 'react';
import { Modal as AntdModal, ConfigProvider } from 'antd';
import { ModalProps as AntdModalProps } from 'antd/lib/modal';

import { AppContext } from '@/utils/appProvider';
import classnames from 'classnames';
import './index.less';

interface ModalProps extends AntdModalProps {}

const Modal: React.FC<ModalProps> & ModalProps = props => {
  const { children, className } = props;
  const { prefixCls } = React.useContext(AppContext);
  return (
    <ConfigProvider autoInsertSpaceInButton={false}>
      <AntdModal {...props} wrapClassName={classnames(`${prefixCls}-modal`, className)}>
        {children}
      </AntdModal>
    </ConfigProvider>
  );
};

export default Modal;
